import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { CampaniaDescuentoMora } from '../_models/campania-descuento-mora';

@Injectable({
  providedIn: 'root'
})
export class CampaniaDescuentoMoraService {

  private rutServicioCampania = AppSettings.rutServiciosAPL + '/api/campaniasDescuentosDiasMora/';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoCampanias() {
    return this.httClient.get( this.rutServicioCampania ).pipe( map( res => res as CampaniaDescuentoMora[] ) );
  }

  listadoCampaniasHabilitadas() {
    return this.httClient.get( this.rutServicioCampania + 'enabled' ).pipe( map( res => res as CampaniaDescuentoMora[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioCampania + id ).pipe( map( res => res as CampaniaDescuentoMora ) );
  }

  obtenerPorCampania( id: string ) {
    return this.httClient.get( this.rutServicioCampania + 'campania/' + id ).pipe( map( res => res as CampaniaDescuentoMora[] ) );
  }

  crear( campania: CampaniaDescuentoMora ) {
    campania.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCampania, campania ).pipe( map( res => res as CampaniaDescuentoMora ) );
  }

  actualizar( campania: CampaniaDescuentoMora ) {
    campania.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioCampania, campania ).pipe( map( res => res as any ) );
  }


}
